<template>
  <div class="marginTop" :class="{ marginBottom: !toogleMicroApp }">
    <header id="header" class="topo d-flex align-items-center" v-if="toogleMicroApp || MODULOS.MARKETPLACE">
      <div class="container p-0">
        <nav class="navbar navbar-expand-lg grid-container" :class="{
          'navbar-without-marketplace': !MODULOS.MARKETPLACE,
          'navbar-inside-webapp': !toogleMicroApp,
        }">
          <div class="grid-menu">
            <button class="btn-menu btn btn-outline-light d-flex flex-column border-0" type="button"
              @click="showMenu = !showMenu">
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div class="grid-logo">
            <a :href="URL_SITE" tag="a" class="navbar-brand" v-if="URL_SITE">
              <img :src="LOGO_TOPO" style="width: 225px; max-width: 60%" />
            </a>
            <router-link v-else :to="`${MODULOS.LANDING ? '/loja' : MODULOS.CLUBE_DESCONTO === true ? '/servico/clube-desconto' :'/'}`" tag="a" class="navbar-brand">
              <img :src="LOGO_TOPO" style="width: 225px; max-width: 60%" />
            </router-link>
          </div>
          <div class="grid-pesquisa" v-if="MODULOS.MARKETPLACE">
            <form class="input-group" v-on:submit.prevent="obterPesquisa">
              <input class="form-control" type="search" placeholder="Procure por um produto" v-model="search" />
              <!-- @input="pesquisar($event)" -->
              <button class="btn btn-secondary" style="
                  border-bottom-left-radius: 0;
                  border-top-left-radius: 0;
                  box-shadow: none;
                " type="submit">
                Buscar
              </button>
            </form>
          </div>
          <div class="grid-login-carrinho">
            <div class="menu_login">
              <a @click="goTo(`/login`)" class="d-flex flex-column nav-link" v-if="!user">
                <strong>Bem-vindo :)</strong>
                <span>Entre ou cadastre-se</span>
              </a>
              <div v-if="user" class="dropdown">
                <a class="
                    align-items-center
                    d-flex
                    dropdown-toggle
                    justify-content-between
                    nav-link
                  " @click="subMenuLogin = !subMenuLogin">
                  <div class="d-flex flex-column w-100">
                    <strong>Bem-vindo :)</strong>
                    <div class="ellipsis">
                      {{ user.conta.contaTipo == 'PESSOA_JURIDICA' ? user.pessoaJuridica.razaoSocial : user.pessoa.nome
                      }}
                    </div>
                  </div>
                </a>
                <div v-if="MODULOS.CLUBE_DESCONTO !== true" class="dropdown-menu" :class="{ show: subMenuLogin }">
                  <a @click="goTo(`/meu-perfil`)" class="dropdown-item">
                    Minha Conta
                  </a>
                  <!-- <a @click="goTo(`/indicacao`)" class="dropdown-item">
                    Minhas indicações
                  </a> -->
                  <a @click="goTo(`/assinaturas`)" class="dropdown-item"
                    v-if="MODULOS.ASSINATURA || MODULOS.PORTAL_DO_CLIENTE">
                    Minhas Assinaturas
                  </a>
                  <a @click="goTo(`/alterar-senha`)" class="dropdown-item">
                    Alterar Senha
                  </a>
                  <a @click="goTo(`/pedidos`)" class="dropdown-item" v-if="MODULOS.MARKETPLACE">
                    Meus Pedidos
                  </a>
                  <a @click="logout()" class="dropdown-item"> Sair</a>
                </div>
              </div>
            </div>
            <div class="menu_carrinho cursor-pointer" v-if="
              (this.$route.name === 'loja' || this.$route.name === 'home') &&
              MODULOS.MARKETPLACE
            ">
              <a class="d-flex justify-content-between p-3" @click="carrinhoCompras">
                <img :src="iconCarrinho" class="mr-3" />
                <span>
                  <b>{{ this.somaItens() }}</b>
                </span>
              </a>
            </div>
          </div>
          <div class="grid-todasCategorias" v-if="exibirCategorias">
            <div class="col-12 collapse navbar-collapse p-0"
              :class="{ show: showMenu, 'd-lg-none': !MODULOS.MARKETPLACE }">
              <ul class="navbar-nav mr-auto flex-wrap pb-3 overflow-hidden" style="height: 48px; z-index: 9">
                <li class="nav-item menu_login">
                  <a @click="goTo(`/login`)" class="d-flex flex-column p-3 text-white hidden" v-if="!user">
                    <strong>Bem-vindo :)</strong>
                    <span>Entre ou cadastre-se</span>
                  </a>
                  <div v-if="user" class="align-items-stretch d-flex flex-column p-3">
                    <a class="d-flex">
                      <strong>Bem-vindo :)
                        {{ !!user.pessoa && user.pessoa.nome }}</strong>
                    </a>
                    <a @click="goTo(`/meu-perfil`)" class="dropdown-item" v-if="MODULOS.MARKETPLACE">
                      Perfil
                    </a>
                    <a @click="goTo(`/assinaturas`)" class="dropdown-item">
                      Minhas Assinaturas
                    </a>
                    <a @click="goTo(`/alterar-senha`)" class="dropdown-item">
                      Alterar Senha
                    </a>
                    <a @click="goTo(`/pedidos`)" class="dropdown-item" v-if="MODULOS.MARKETPLACE">
                      Meus Pedidos
                    </a>
                    <a @click="logout()" class="dropdown-item"> Sair </a>
                  </div>
                </li>

                <li class="nav-item px-3 mt-2 d-lg-none" v-if="MODULOS.MARKETPLACE">
                  <a @click="goTo(`${MODULOS.LANDING ? '/loja' : '/'}`)" class="dropdown-item px-0"
                    style="font-size: 1rem">
                    Loja
                  </a>
                </li>
                <li class="nav-item px-3 mt-2 d-lg-none">
                  <a @click="goTo(`/categorias`)" class="dropdown-item px-0" style="font-size: 1rem"
                    v-if="MODULOS.MARKETPLACE">
                    Categorias
                  </a>
                </li>
                <li v-for="(category, i) in objCategoria" :key="i" :class="[
                  { active: categoriaSelecionada === category },
                  'nav-item px-3 mt-2 d-none d-lg-flex',
                ]">
                  <Dropdown :onClick="selectCategory" :items="category" />
                </li>
                <li class="nav-item d-none d-lg-flex mt-2" v-if="MODULOS.MARKETPLACE">
                  <Dropdown :onClick="selectCategory" :items="objCategoria" />
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
    <footer class="d-flex justify-content-around" v-if="!toogleMicroApp && !MODULOS.ASSINATURA">
      <a class="
          btn
          w-100
          d-flex
          flex-column
          align-items-center
          justify-content-center
          pb-2
          pt-3
        " v-if="MODULOS.ASSINATURA" @click="goTo(`${MODULOS.LANDING ? '/loja' : '/'}`)">
        <img class="mb-1" style="filter: invert(1); width: 20px" src="@/assets/images/home.png" />
        <small v-if="MODULOS.ASSINATURA">Planos</small>
      </a>
      <!-- <a class="
          btn
          w-100
          d-flex
          flex-column
          align-items-center
          justify-content-center
          pb-2
          pt-3
        " v-if="MODULOS.MARKETPLACE" @click="goTo(`${MODULOS.LANDING ? '/loja' : '/'}`)">
        <img class="mb-1" style="filter: invert(1); width: 20px" src="@/assets/images/marketplace.png" />
        <small>Compras</small>
      </a> -->
      <!-- <a class="
          btn
          w-100
          d-flex
          flex-column
          align-items-center
          justify-content-center
          pb-2
          pt-3
        " v-if="MODULOS.PORTAL_DO_CLIENTE" @click="goTo(`/assinaturas`)">
        <img class="mb-1" style="filter: invert(1); width: 20px" src="@/assets/images/assinatura.png" />
        <small>Minha Assinaturas</small>
      </a> -->
      <!-- <a class="
          btn
          w-100
          d-flex
          flex-column
          align-items-center
          justify-content-center
          pb-2
          pt-3
        " v-if="MODULOS.MARKETPLACE" @click="goTo(`/pedidos`)">
        <img class="mb-1" style="filter: invert(1); width: 20px" src="@/assets/images/pedidos.png" />
        <small>Meus Pedidos</small>
      </a> -->
    </footer>
  </div>
</template>

<script>
import Dropdown from "../components/main/Dropdown";
import { APIService } from "../APIService";
const apiService = new APIService();
const VueScrollTo = require("vue-scrollto");

export default {
  name: "Header",
  props: ["toogleMicroApp"],
  components: { Dropdown },
  data() {
    return {
      MODULOS: window.MODULOS,
      URL_SITE: window.SITE,
      heightHeader: 140,
      menu: false,
      showMenu: false,
      objCategoria: null,
      categoriaSelecionada: "",
      routerLoja: true,
      subMenuLogin: false,
      todasCategorias: false,
      timerPesquisa: null,
      iconCarrinho: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='23.625' height='21' viewBox='0 0 23.625 21'%3E%3Cpath id='ico-carrinho' d='M21.661,12.359,23.6,3.828a.984.984,0,0,0-.96-1.2H6.53L6.154.787A.984.984,0,0,0,5.19,0H.984A.984.984,0,0,0,0,.984v.656a.984.984,0,0,0,.984.984H3.851L6.732,16.711a2.3,2.3,0,1,0,2.75.351h8.6a2.3,2.3,0,1,0,2.609-.427l.226-1a.984.984,0,0,0-.96-1.2H8.946l-.268-1.313H20.7A.984.984,0,0,0,21.661,12.359Z' fill='%23${window.COR_TEXTO.replace(
        "#",
        ""
      )}'/%3E%3C/svg%3E`,
      LOGO_TOPO:
        window.LOGO_TOPO ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png",
      search: "",
      categoriaId: 0,
      exibirCategorias: true
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }

  },
  watch: {

  },
  mounted() {
    this.routerLoja = this.routerCurrent();
    this.obterCategoria();
    this.$nextTick(() => this.wacthHeigth());
  },
  created() {
    window.addEventListener("resize", this.wacthHeigth);
  },
  destroyed() {
    window.removeEventListener("resize", this.wacthHeigth);
  },
  methods: {
    wacthHeigth() {
      this.heightHeader = `${document.getElementById("header")
        ? document.getElementById("header").offsetHeight
        : ""
        }`;
      const bodyStyles = document.body.style;
      bodyStyles.setProperty("--heightHeader", this.heightHeader);
    },
    obterCategoria() {
      apiService.obterCategoria().then((res) => {
        const objTodas = { id: 0, nome: "Todas", posicaoOrdem: 1 };
        let resSort = this.ordenarPorNomeCategorias(res, "nome");
        resSort = this.ordenarPorNomeCategorias(res, "posicaoOrdem");
        this.objCategoria = [objTodas, ...resSort];
      });
    },
    ordenarPorNomeCategorias(list, orderBy) {
      return list.sort((a, b) => {
        a.subCategorias =
          a.subCategorias.length > 0
            ? this.ordenarPorNomeCategorias(a.subCategorias)
            : [];
        b.subCategorias =
          b.subCategorias.length > 0
            ? this.ordenarPorNomeCategorias(b.subCategorias)
            : [];
        return a[orderBy] > b[orderBy] ? 1 : b[orderBy] > a[orderBy] ? -1 : 0;
      });
    },
    logout() {
      this.subMenuLogin = false;
      this.$store.dispatch("loginApp", null);
      // this.$store.dispatch("limparPedido");
      this.goTo(`${this.MODULOS.LANDING ? "/loja" : "/login"}`);
    },
    obterPesquisa() {
      this.$store.dispatch("pesquisarProduto", this.search);
    },
    selectCategory(categoria) {
      this.$store.dispatch("selecionaCategoria", categoria);
      VueScrollTo.scrollTo("#produtos", 500, {
        offset: window.innerWidth > 420 ? -this.heightHeader - 30 : -120,
      });
      this.todasCategorias = false;
      this.showMenu = false;
      this.search = "";
    },
    carrinhoCompras() {
      VueScrollTo.scrollTo("#carrinho_compras", 500, {
        offset: window.innerWidth > 420 ? -this.heightHeader - 30 : -120,
      });
    },
    routerCurrent() {
      return window.location.hash.includes("loja");
    },
    somaItens() {
      let soma = 0;
      this.$store.state.pedido.itens.forEach((o) => (soma += o.quantidade));
      return soma;
    },
    goTo(path) {
      this.subMenuLogin = false;
      this.showMenu = false;
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss">
.marginTop+* {
  padding-top: calc(var(--heightHeader) * 1px);
}

.marginBottom+* {
  margin-bottom: 80px;
}
</style>
<style scoped lang="scss">
@media (min-width: 992px) {
  nav .d-lg-none {
    display: none !important;
  }
}

a {
  cursor: pointer;

  small {
    color: var(--cor-texto);
  }
}

li.nav-item>div {
  display: flex;
  align-items: center;
}

.topo {
  background: var(--cor-principal);
  color: var(--cor-texto);
  width: 100%;
  background-size: cover;
  background-position: center;
  position: fixed;
  top: 0;
  z-index: 8;
  border-top: 8px solid var(--cor-secundaria);
}

.topo .unidade {
  position: relative;
}

.topo .unidade img {
  position: absolute;
  top: 20px;
  left: -66px;
}

.input-group {
  border-bottom: 1px solid #fff;
}

.input-group input {
  background: transparent;
  border: none;
  color: #fff;
  box-shadow: none !important;
}

.input-group button {
  background: transparent;
  border: none;
  color: #fff;
}

.topo .unidade .nome_unidade {
  font-size: 3em;
  font-weight: 800;
  display: block;
}

.cursor-pointer {
  cursor: pointer;
}

.menu_carrinho {
  position: fixed;
  background: var(--cor-principal);
  right: 16px;
  top: 8px;
  z-index: 1040;
  transition: box-shadow 0.4s;
}

.menu_carrinho:hover {
  -webkit-box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.25);
}

.navbar-nav a {
  color: var(--cor-texto) !important;
  margin: 4px;
}

a.navbar-brand {
  text-align: center;
}

.btn-comprar {
  background-color: red;
  padding: 0.5rem 16px 4px !important;
  border-radius: 34px;
  display: inline-block;
}

footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--cor-principal);
  z-index: 10;
}

@media (max-width: 992px) {
  header {
    position: fixed;
    top: 0;
    z-index: 10;
  }

  .menu_carrinho {
    top: 4px;

    a {
      padding: 0.75rem !important;
    }
  }

  .collapse.show {
    position: absolute;
    top: 52px;
    left: 0;
    background: var(--cor-principal);
    z-index: 414;
    width: 100%;
    filter: brightness(0.9);
  }

  .btn-comprar {
    padding: 0.5rem 16px !important;
  }

  .btn-menu {
    background-color: transparent !important;
    box-shadow: none !important;

    span {
      width: 20px;
      height: 2px;
      margin: 2px 0;
      background: var(--cor-texto);
    }
  }
}

.btn-category {
  border: none;
  border-bottom: 2px solid transparent;
  background-color: transparent;
  margin: 0 8px;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &.select {
    border-bottom-color: var(--cor-principal);
    color: #fff;
  }
}

a.nav-link {
  white-space: nowrap;
}

.menu_login {
  width: calc(100% - 80px);
  font-size: 0.9rem;

  &.nav-item {
    display: none;
  }

  a {
    text-decoration: none;

    &:hover span {
      text-decoration: underline;
    }
  }
}

.navbar-inside-webapp {
  display: none;
}

.navbar-inside-webapp .hidden {
  display: none !important;
}

.grid-container {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1fr 1fr;
  gap: 0px 0px;
  grid-template-areas:
    "primeira-linha-1 primeira-linha-2 primeira-linha-3"
    "segunda-linha segunda-linha segunda-linha";

  &.navbar-without-marketplace {
    grid-template-rows: 1fr;
  }

  &.navbar-inside-webapp .grid-logo {
    display: none !important;
  }

  &.navbar-inside-webapp {
    .grid-login-carrinho {
      grid-area: none;
      position: fixed;
      bottom: 0;

      .menu_login {
        display: none !important;
      }

      .menu_carrinho {
        bottom: 84px;
        top: inherit;
        border-radius: 16px;
        box-shadow: 0 3px 6px #808080;
      }
    }
  }
}

.grid-todasCategorias {
  grid-area: segunda-linha;
}

.grid-menu {
  display: none;
}

.grid-logo {
  grid-area: primeira-linha-1;
}

.grid-pesquisa {
  grid-area: primeira-linha-2;
}

.grid-login-carrinho {
  grid-area: primeira-linha-3;
  width: 250px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

@media (max-width: 991px) {
  .menu_login {
    display: none;
  }

  .navbar-inside-webapp {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-template-areas: "segunda-linha segunda-linha primeira-linha-1";

    .grid-menu {
      width: initial;
    }
  }

  .grid-todasCategorias {
    .menu_login {
      display: initial;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      font-size: 1rem;

      .dropdown-item {
        background-color: initial;
      }

      a {
        padding: 0;
      }
    }
  }

  .grid-menu {
    grid-area: primeira-linha-1;
    display: initial;
    width: 100px;
  }

  .grid-logo {
    grid-area: primeira-linha-2;
    text-align: center;
  }

  .grid-pesquisa {
    grid-area: segunda-linha;
  }

  .grid-login-carrinho {
    width: 100px;
    grid-area: primeira-linha-3;
  }

  .dropdown,
  .dropdown-menu {
    display: none !important;
  }

  .navbar-nav {
    height: initial !important;
    overflow: initial;
  }
}
</style>
